








































import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../../router/routenames";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";
import DeskCompilation from "../widgets/DeskCompilation.vue";
import { Action, Getter } from "vuex-class";

import { api as friendsApi } from "../../store/modules/friends";
import { api as userApi } from "../../store/modules/user";
import { api as deskApi } from "../../store/modules/desk";
import { FriendRef } from "@dokogd/shared";
import firebase from "firebase/app";

@Component({ components: { DoKoHtmlDialog, DeskCompilation, DoKoBtn } })
export default class DoKoCreateDesk extends Vue {
  loading = false;
  deskName = "Tischname";
  participantsList: FriendRef[] = [];

  @Getter(userApi.getters.getUserId, { namespace: userApi.namespace })
  userId!: string;

  @Action(friendsApi.actions.listenForFriends, {
    namespace: friendsApi.namespace,
  })
  listenForFriends!: () => Promise<void>;

  @Action(friendsApi.actions.stopListenForFriends, {
    namespace: friendsApi.namespace,
  })
  stopListenForFriends!: () => Promise<void>;

  @Action(deskApi.actions.create, {
    namespace: deskApi.namespace,
  })
  sendCreateDesk!: (payload: any) => Promise<{ data: { deskId: string } }>;

  get valid() {
    const uniqueIds = new Set(this.participantsList.map((p) => p.id));
    return uniqueIds.size >= 4 && uniqueIds.has(this.userId);
  }

  createDesk() {
    this.loading = true;
    this.sendCreateDesk({
      name: this.deskName.trim(),
      participants: this.participantsList,
      allowSpectate: true,
    })
      .then(({ data: { deskId } }) => {
        console.log("RES", deskId);

        this.$router.push({
          name: ROUTE_NAMES.DESK,
          params: {
            deskId,
          },
        });
      })
      .catch((err) => {
        console.error("createDesk failed", err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  created() {
    this.listenForFriends();
  }

  beforeDestroy() {
    this.stopListenForFriends();
  }
}
